import { FilterSubmitButton, useFilterFormError } from '@/components/common/Filter'
import { InputColors, InputSelect } from '@/components/common/Input'
import {
  CARD_FILTER_COLORS_OPERATOR_LABELS,
  CARD_FILTER_COLORS_OPERATORS,
  type CardFilterColorsPartialType,
  type CardFilterColorsType,
} from '@/defs/cardFilters'
import { type ColorType } from '@/defs/mtg'

import styles from './GalleryCardFiltersFormColors.module.scss'

const OPTIONS = CARD_FILTER_COLORS_OPERATORS.map((o) => ({
  label: CARD_FILTER_COLORS_OPERATOR_LABELS[o].label,
  value: o,
}))

type Props = {
  cardFilter: CardFilterColorsPartialType
  onUpdate: (f: CardFilterColorsPartialType) => void
}

export const GalleryCardFiltersFormColors = ({ cardFilter, onUpdate }: Props) => {
  const { colors = [], operator } = cardFilter
  const operatorError = useFilterFormError(!operator)
  const colorsError = useFilterFormError(colors.length === 0)

  const onColorsUpdate = (colors: ColorType[]) => {
    onUpdate({ ...cardFilter, colors })
  }

  const onOperatorUpdate = (operator: CardFilterColorsType['operator']) => {
    onUpdate({ ...cardFilter, operator })
  }

  return (
    <div className={styles.container}>
      <div className={styles.fields}>
        <div className={styles.operator}>
          <InputSelect
            borderColor={operatorError.warn ? 'warning' : undefined}
            colorScheme='muted'
            onSelect={onOperatorUpdate}
            options={OPTIONS}
            placeholder='Choose operator'
            value={operator}
            wiggle={operatorError.wiggle}
          />
        </div>
        <InputColors
          borderColor={colorsError.warn ? 'warning' : undefined}
          colors={colors}
          onChange={onColorsUpdate}
          wiggle={colorsError.wiggle}
        />
      </div>
      <FilterSubmitButton />
    </div>
  )
}
